import { String } from 'aws-sdk/clients/cloudhsm'
import React, { useEffect, useState } from 'react'
import './styles.scss'
import Scrollchor from 'react-scrollchor'
import { useWindowSize } from './useWindowSize'
import browsercheck from '@ta-interaktiv/browsercheck'

const isMobile = browsercheck.isMobile

export const ChapterNavigation = ({
  content,
  current,
  setCurrent
}: {
  content: {
    name: JSX.Element | String
    id: string
  }[]
  current?: string
  setCurrent?: React.Dispatch<React.SetStateAction<string>>
}) => {
  const [hovered, setHovered] = useState<number | undefined>(undefined)
  const [open, setopen] = useState<boolean>(false)
  const { width, isMobile } = useWindowSize()

  return (
    <div
      className={
        'ChapterNavigation ' +
        (isMobile ? 'mob ' : 'desk ') +
        (open ? 'open' : 'closed')
      }
    >
      <div className='wrapper'>
        <div className='content'>
          {content.map((m, i) => {
            return (
              <Scrollchor
                to={m.id}
                key={i}
                animate={{ offset: isMobile ? 0 : -20 }}
                className={'scroll ' + (hovered === i ? 'hov' : '')}
              >
                <div
                  className={'entry ' + (current === m.id ? 'current' : '')}
                  onClick={() => {
                    if (setCurrent) setCurrent(m.id)

                    setopen(false)
                  }}
                  onMouseEnter={!isMobile ? () => setHovered(i) : undefined}
                  onMouseLeave={
                    !isMobile ? () => setHovered(undefined) : undefined
                  }
                >
                  {m.name}
                </div>
              </Scrollchor>
            )
          })}
        </div>
        <div className='switch' onClick={() => setopen(!open)}>
          <img src={require('./icn_close.svg')} className='open' />
          <img src={require('./icn_menu.svg')} className='close' />
        </div>
      </div>

      {/* <div className='wrapper'>
        <div
          className={isMobile ? 'menu' : 'menud'}
          onClick={() => {
            setopen(false)
          }}
        >
          {(isMobile || !isMobile) && (
            <>
              {content.map((m, i) => {
                return (
                  <Scrollchor
                    to={m.id}
                    key={i}
                    className={'scroll ' + (hovered === i ? 'hov' : '')}
                  >
                    <div
                      className={isMobile ? 'entry' : 'entryd'}
                      onMouseEnter={() => setHovered(i)}
                      onMouseLeave={() => setHovered(undefined)}
                    >
                      {hovered === i || isMobile ? m.name : m.id}
                    </div>
                  </Scrollchor>
                )
              })}
            </>
          )}
        </div>
        {isMobile && (
          <div className='switch' onClick={() => setopen(!open)}>
            <img
              src={
                open ? require('./icn_close.svg') : require('./icn_menu.svg')
              }
            />
          </div>
        )}
      </div> */}
    </div>

    // <div
    //   className={
    //     'ChapterNavigation ' + (isMobile ? 'mob ' : ' ') + (open ? 'open' : '')
    //   }
    // >
    //   <div className='Menu'>
    //     {!isMobile && <div className='Border' />}

    //     {width &&
    //       (isMobile || open) &&
    //       content.map((m, i) => {
    //         return (
    //           <Scrollchor to={m.id} key={i} className='scroll'>
    //             <div
    //               className={'Entry'}
    //               onMouseEnter={() => setHovered(i)}
    //               onMouseLeave={() => setHovered(undefined)}
    //             >
    //               <div className='label'>
    //                 {' '}
    //                 {hovered === i || isMobile ? m.name : m.id}
    //               </div>
    //               {/* <i className=' arrow right icon' /> */}
    //             </div>
    //           </Scrollchor>
    //         )
    //       })}
    //     {width && isMobile && (
    //       <>
    //         {!open && (
    //           <div className={'Switch'} onClick={() => setopen(!open)}>
    //             <img src={require('./chapter_icon.png')} />
    //           </div>
    //         )}
    //         {open && (
    //           <div className={'Switch'} onClick={() => setopen(!open)}>
    //             X
    //           </div>
    //         )}
    //       </>
    //     )}
    //   </div>
    // </div>
  )
}
